import { memo } from 'react';
import styled from './index.module.scss';
import useRules from './useRules';
import getLocal from '@/app/utils/getLocal';

const Footer = memo(() => {
    const { locale } = getLocal();
    const { rules } = useRules(locale);

    return (
        <div className={styled.Footer}>
            <div className="fy2025-section-content">
                <ul>
                    {rules.map((item, ind) => (
                        <li key={ind} dangerouslySetInnerHTML={{ __html: item }}></li>
                    ))}
                </ul>
            </div>
        </div>
    );
});

Footer.displayName = 'Footer';
export default Footer;
